import { useCallback } from 'react';
import { router, type Href } from 'expo-router';
import { useUIStore } from '../store/uiStore';

/**
 * Gate in front of the observation composer (client ask, Sept 2026:
 * "guidance on what to look for and why"). First-time-per-device: stashes
 * `path` and opens ObservationGuidanceSheet, whose Continue button marks
 * the flag seen and pushes the stashed path. Every visit after that,
 * `guideThen` is a plain `router.push`.
 *
 * Callers gate this behind their own auth step (e.g. CreateActionSheet's
 * ensureScoutThen) — guideThen only decides seen vs. unseen, not whether
 * the user is allowed to post at all.
 */
export function useObservationGuidance() {
  const guideThen = useCallback(async (path: Href) => {
    // The flag is null until hydrated from storage. Nothing else mounts a
    // hydrate for it, so do it here on first use; otherwise a device that
    // pressed Continue last week would see the sheet on every press.
    if (useUIStore.getState().hasSeenObservationGuidance === null) {
      await useUIStore.getState().hydrateObservationGuidance();
    }
    const { hasSeenObservationGuidance, openSheet, setObservationGuidanceNext } =
      useUIStore.getState();
    if (hasSeenObservationGuidance === true) {
      router.push(path);
      return;
    }
    setObservationGuidanceNext(path as string);
    openSheet('observationGuidance');
  }, []);

  return { guideThen };
}
